import Joi from 'joi';

export const generalSettingsFromValidationSchema = {
  shopName: Joi.string().min(3).max(200).required(),
  shopUrl: Joi.string().uri(),
};
